// extracted by mini-css-extract-plugin
export default {"quarter_title":"YQMReport_quarter_title__8azK0","table_striped":"YQMReport_table_striped__Vm8I9","td_end":"YQMReport_td_end__vfgbq","td_start":"YQMReport_td_start__io4N4"};